import React, { Suspense, useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import PublicHome from './PublicHome';
import PublicLanguageProvider from './PublicLanguage';
import { isLegacyFaqRoute, isPublicPage } from './routes';
import ReaderApp from './ReaderEntry';

function currentView() {
  const { pathname, hash } = window.location;
  return isLegacyFaqRoute(pathname, hash)
    ? 'faq-redirect'
    : isPublicPage(pathname, hash)
      ? 'public'
      : 'reader';
}

export default function SiteEntry() {
  const [view, setView] = useState(currentView);
  useEffect(() => {
    const sync = () => setView(currentView());
    window.addEventListener('hashchange', sync);
    window.addEventListener('popstate', sync);
    return () => {
      window.removeEventListener('hashchange', sync);
      window.removeEventListener('popstate', sync);
    };
  }, []);

  useEffect(() => {
    if (view === 'faq-redirect') {
      window.location.replace('/faq/');
    }
  }, [view]);
  if (view === 'faq-redirect') {
    return (
      <p role="status">
        <a href="/faq/">Opening FAQ…</a>
      </p>
    );
  }

  // Existing /#/login, payment callbacks and bookmarked hash links still reach the
  // original router. Moving its mount to /study/ does not alter its route contract.
  if (view === 'public') {
    return (
      <PublicLanguageProvider>
        <PublicHome />
      </PublicLanguageProvider>
    );
  }
  return (
    <Suspense
      fallback={
        <p role="status" style={{ padding: 32 }}>
          Opening the Bible…
        </p>
      }
    >
      <HashRouter>
        <ReaderApp />
      </HashRouter>
    </Suspense>
  );
}
